import { Logout, SetNewDocsUploaded } from 'src/constants/actionTypes'
import { Action } from 'src/utils/reduxUtils'
import { DocumentsState } from './types'

const initialState = {
  isNewDocsUploaded: false,
}

export const documentsReducer = (
  state: DocumentsState = initialState,
  action: Action<any>,
): DocumentsState => {
  switch (action.type) {
    case SetNewDocsUploaded.type.SUCCESS:
      return {
        ...state,
        isNewDocsUploaded: action.payload,
      }
    case Logout.type.SUCCESS:
      return initialState
    default:
      return state
  }
}
